/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { TypeOfTheme } from 'src/constants/theme.constant';

export class LocalStorageRepository {
  
  static setUiTheme(theme: TypeOfTheme) {
    localStorage.setItem('theme', theme);
  }

  static getUiTheme() {
    const currentTheme = localStorage.getItem('theme');
    return currentTheme?? TypeOfTheme.Light;
  }

}
